module.exports = __webpack_public_path__ + "static/media/fallback_product_img.13e04741.png";